<template>
  <div class="videocall-notrecorded">
    <svg
      width="90"
      height="78"
      class=" mb-5 mb-lg-8"
      viewBox="0 0 90 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="13"
        y="7"
        width="64"
        height="64"
        rx="7.5"
        fill="#BFBFBF"
      />
      <rect
        x="25.375"
        y="9.5"
        width="36.875"
        height="22.125"
        rx="2.5"
        fill="#F4F4F4"
      />
      <rect
        x="20.375"
        y="39"
        width="49.25"
        height="29.625"
        rx="2.5"
        fill="#F4F4F4"
      />
      <rect
        x="50"
        y="11.875"
        width="7.25"
        height="17.375"
        fill="#BFBFBF"
      />
      <path
        d="M5 73.0851L85 5"
        stroke="#F4F4F4"
        stroke-width="9.83"
        stroke-linecap="round"
      />
      <path
        d="M5 73.0851L85 5"
        stroke="#BFBFBF"
        stroke-width="3.81"
        stroke-linecap="round"
      />
    </svg>
    <div class="text-center">
      {{ $t('empty') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoCallEmpty',
};
</script>

<style lang="scss" scoped>
.videocall-notrecorded {
  height: 20rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.25rem;
  background-color: #f5f5f5;
  border-radius: 0 0 0.5rem 0.5rem;
  font-size: 1.125rem;
  font-weight: 500;
}
</style>

<i18n locale="en" lang="yaml">
  empty: 'The video call was completed, but the recording was not saved due to the lack of video and audio materials.'

</i18n>

<i18n locale="ru" lang="yaml">
  empty: 'Видеозвонок завершен, но запись не сохранилась из-за отсутствия видео и аудио материалов'
</i18n>
